<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img mt-2">
            <div class="col-md-6 m-auto">
                <br>
                <div class="card" v-if="!this.produtoBipado">
                    <div class="card-header small text-white p-0" :style="{ backgroundColor: moduloAtual().color }">
                        SAIDA MANUAL
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 small text-left">
                        <select class="form-control form-control-sm" id="cliente">
                            <option value="">
                                -- Selecione o Cliente --
                            </option>
                            <option v-for="option in clientes" :value="option.id" :key="option.id">
                                {{ option.fantasia }} - {{ option.id }}
                            </option>
                            
                        </select>

                        <div class="mt-2 small">
                            <InputDefaultApp
                                key="produtoInput"
                                inputPlaceHolderSufixo="Digite o produto"
                                titleScan="Escanear Produto"
                                typeInputMode="text"
                                @displayScanFunction="buscarProduto"
                                :enterKey="(e) => buscarProduto(e.target.value)"
                                idInput="produtoInput"
                                :errorMessage="this.produtoErrorMessage"
                                :toUpperCase="true"
                            />
                        </div>          
                    </div>
                </div>

                <div class="card" v-if="this.produtoBipado">
                    <div class="card-header small text-white p-0" :style="{ backgroundColor: moduloAtual().color }">
                        SAIDA MANUAL
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 small text-left">

                        <div class="card-body small text-left p-2">
                            
                            <span class="font-weight-bold small">{{ this.produtoBipado.descricao }}</span>
                            <br>
                            <span class="font-weight-bold">SKU</span>:
                            <span class="rounded pl-2 pr-2 bg-warning ml-2">
                                {{ this.produtoBipado.sku }}
                            </span>
                            <br>
                            <span class="font-weight-bold">Código Interno</span>:
                            <span class="rounded pl-2 pr-2 bg-warning ml-2">
                                {{ this.produtoBipado.codigoprodutoabacos }}
                            </span>
                            
                        </div>
                    </div>
                </div>

                <div class="card small mt-2" v-if="this.produtoBipado">
                    <div class="card-header text-white bg-secondary p-0">
                        ENDEREÇOS
                    </div>
                    <div class="card-body p-1" >

                        <div class="div-scroll">
                            <div class="border p-2 rouded w-100 mb-1" v-for="item in produtoBipado.enderecos" :key="item.idenderecamento">
                                <span class="font-weight-bold">{{ item.descricao }}</span>
                                <br>
                                <span class="font-weight-bold small">QTDE</span>:
                                <span class="rounded pl-2 pr-2 bg-warning ml-2">
                                    {{ item.qtde }}
                                </span>
                                <span class="font-weight-bold small ml-3">Pulmão</span>:
                                <span class="rounded pl-2 pr-2 bg-warning ml-2">
                                    {{ item.pulmao }}
                                </span>
                               
                                <br>
                                <span class="font-weight-bold small">Prod. Quarentena</span>:
                                <span class="rounded pl-2 pr-2 bg-warning ml-2">
                                    {{ item.prod_quarentena }}
                                </span>
                                <br>
                                <span class="font-weight-bold small">End. Quarentena</span>:
                                <span class="rounded pl-2 pr-2 bg-warning ml-2">
                                    {{ item.end_quarentena }}
                                </span>
                                <br>
                                <span class="font-weight-bold small">LOTE/VALIDADE</span>:
                                <span class="rounded pl-2 pr-2 bg-warning ml-2">
                                    {{ item.lote + " - " + dateFormat(item.validade) }}
                                </span>
                                <br>
                                <span class="font-weight-bold small">Data</span>:
                                <span class="ml-2">
                                    {{ dateFormat(item.datagravacao)  }}
                                </span>

                                <button class="btn btn-sm btn-success button-saida" @click="showModal(item)">
                                    <em class="fa fa-arrow-right"></em>
                                </button>
                            </div> 
                        </div>
                        
                    </div>
                </div>

                <div class="mt-5 text-center text-secondary" v-if="!this.produtoBipado">
                    <em class="fa fa-info-circle fa-3x mb-2"></em>
                    <br>
                    <span class="small">Informe o código do produto!</span>
                </div>

                <button class="btn btn-danger btn-sm w-100 mt-2" v-if="this.produtoBipado" @click="reiniciar">
                    Trocar cliente ou produto
                    <em class="fa fa-undo ml-2"></em>
                </button>
            </div>
        </div>

        <Modal
            id="modal1"
            :title="enderecoDescricao"
            confirmText="Confirmar"
            cancelText="Cancelar"
            :confirmFunction="saidaManual"
        >
            <div class="alert alert-warning p-1" v-if="this.errorModal">
                {{ this.errorModal }}
            </div>
           <div class="text-left">
                <label for="lote">* QUANTIDADE</label>
                <input type="number"
                class="form-control form-control-sm"
                autocomplete="off"
                id="quantidade">

                <label for="lote">* MOTIVO</label>
                <input type="text"
                class="form-control form-control-sm"
                autocomplete="off"
                id="motivo">
           </div>
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>

        <LogoutModal />
        <FooterBar />
    </div>
</template>
  
<script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import InputDefaultApp from '../components/InputDefaultApp.vue'
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUsername, getPerfil, getUserId } from '../services/api'
    import $ from "jquery"
    import audioService from '@/services/audioService.js'
    import { dateFormat } from '../utils';
    import Modal from "../components/Modal.vue"

    export default {
        name: 'SaidaManual',
        mixins: [
            ViewMixin
        ],
        components: {
            Topbar,
            LogoutModal,
            FooterBar,
            InputDefaultApp,
            Modal,
        },
    
        data: () => {
            return {
                menus : [],
                categoriaId: null,
                clientes: [],
                enderecoDestino: null,
                produtoErrorMessage: null,
                produtoBipado: null,
                clienteReferencia: null,
                clienteFantasia: null,
                errorModal: null,
                enderecoSelecionado: null,
                enderecoDescricao: null,
                retornoMessage: null,
            };
        },
    
        async mounted() {
            try {
                await this.validarToken();
                await this.listarClientes();

                document.getElementById('cliente').addEventListener('change', function() {
                    $("#produtoInput").focus();
                    $("#produtoInput").select();
                });

            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                alert(e.message);
                } else {
                alert(DEFAULT_ERROR_MESSAGE);
                }      
            }
        },
    
        methods: {
            getUsername,
            getPerfil,
            getUserId,
            dateFormat,

            closeModal(modal) {
                $("#" + modal).modal("hide");
            },

            showMessageSuccess(message) {
                this.retornoMessage = message;
                $("#modalRetorno").modal('show');
            },

            playSoundSuccess() {
                audioService.success();
            },

            playSoundAlert() {
                audioService.ops();
            },

            async validarToken() {
                this.carregando = true;
        
                await api.get("/validar-token");
        
                this.carregando = false;
            },


            reiniciar() {
                this.produtoBipado = null;

                $("#cliente").val("");

                setTimeout(() => {
                    $("#produtoInput").focus();
                    $("#produtoInput").select();
                }, 500);
            },

            async listarClientes() {
                this.carregando = true;
                this.clientes = [];
                
                try {
                    let response = await api.get(`/cliente/listar`);
                    response.data.forEach((e) => {
                        this.clientes.push(e)
                    }, this);

                    setTimeout(() => {
                        $("#produtoInput").focus();
                    }, 500);
                } catch (e) {
                    console.error(e);
                    this.playSoundAlert();
                }
                this.carregando = false;
            },

            async buscarProduto(codigoBarras) {
                this.carregando = true;

                if ($("#cliente").val().trim() === "") {
                    this.produtoErrorMessage = "Informe o cliente!";
                    this.playSoundAlert();
                    this.carregando = false;
                    
                    setTimeout(() => {
                        $("#produtoInput").focus();
                        $("#produtoInput").select();
                    }, 250);

                    return;
                }

                this.clienteReferencia = $("#cliente").val();

                let body = {
                    "idCliente": $("#cliente").val(),
                    "codigoBarras": codigoBarras
                };

                try {
                    let response = await api.post("/outbound/produto/saidamanual", body);

                    if (JSON.stringify(response.data).includes("idprodutos"))
                    {   
                        this.produtoBipado = response.data.produto;
                        this.produtoErrorMessage = null;
                        
                        $("#produtoInput").focus();
                        $("#produtoInput").select();
                    }
                } catch (error) {
                    this.produtoErrorMessage = error.message;
                    this.playSoundAlert();
                    $("#produtoInput").focus();
                    $("#produtoInput").select();
                }

                this.carregando = false;
            },

            showModal(endereco) {

                this.enderecoSelecionado = endereco;
                this.enderecoDescricao = endereco.descricao;

                $("#modal1").modal("show");
                setTimeout(() => {
                    $("#quantidade").focus();
                    $("#quantidade").select();
                }, 500);
            },

            async saidaManual() {
                let quantidade = $("#quantidade").val();
                let motivo = $("#motivo").val();

                if (quantidade.trim() === "") {
                    this.errorModal =  "Informe a quantidade do produto!";
                    this.playSoundAlert();
                    $("#quantidade").focus();
                    this.carregando = false;
                    return;
                }

                if (motivo.trim() === "") {
                    this.errorModal =  "Informe o motivo do produto!";
                    this.playSoundAlert();
                    $("#motivo").focus();
                    this.carregando = false;
                    return;
                }

                try {
                    let body = {
                        "idCliente": this.clienteReferencia,
                        "codigoBarras": this.produtoBipado.codbarras,
                        "idUsuario": getUserId(),
                        "endereco": this.enderecoDescricao,
                        "quantidade": quantidade,
                        "motivo": motivo
                    };

                    let response = await api.post("/outbound/saidamanual", body);
                    $("#modal1").modal("hide");

                    if (JSON.stringify(response).includes("sucesso")) {
                        this.playSoundSuccess();
                        this.showMessageSuccess(response.data.message);
                        

                        $("#quantidade").val("");
                        $("#motivo").val("");

                        for (const item of this.produtoBipado.enderecos) {
                            if (item.descricao === this.enderecoDescricao) {
                                item.qtde = item.qtde - quantidade;
                            }
                        }   
                    }
                } catch (error) {
                    this.errorModal = error.message;
                    this.playSoundAlert();
                    $("#produtoInput").focus();
                    $("#produtoInput").select();
                }
            },
        }
    }
</script>
  
<style scoped lang="scss">    
  
    .home-view {
        height: 100%;
    }
  
    .container-img {
        height: auto;
        display: flex;
        justify-content: center;
        align-self: center;
    }

    .div-scroll {
        width: 100%;
        height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
        text-align: left;
    }

    .button-saida {
        position: relative;
        top: -100px;
        right: -70px;
    }
</style>
  